
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      config: "CONFIG/CONFIG",
    }),
  },

  methods: {
    hide() {
      this.$store.commit("CONFIG/RESET_ALL");
    },
  },
};
